import { render, staticRenderFns } from "./ImpactpolicyAccordionComparison.vue?vue&type=template&id=35493e92&"
import script from "./ImpactpolicyAccordionComparison.vue?vue&type=script&lang=js&"
export * from "./ImpactpolicyAccordionComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports